import React from 'react';
import PropTypes from 'prop-types';
import ProductGridPrice from '../ProductList/ProductGridPrice';

function ProductSliderItem(props) {
    const { item } = props;
    const {
        ID,
        InternalItemID,
        Title,
        IsSale,
        ReSizedProductListingImage,
        Link,
    } = item;

    const imagePath = window.baseURL + ReSizedProductListingImage;
    const image = imagePath || "https://via.placeholder.com/500";

    return (
        <div
            className='product-grid__item slider__item'
            key={`related-product-${ID}`}
        >
            <a href={Link} className='product-grid__link' title={Title}>
                <figure className='photo product-grid__photo'>
                    <img src={image} className='photo__image' width={500} height={500} alt={Title} />
                </figure>
                <div className='product-grid__content'>
                    <span className='product-grid__heading'>
                        {InternalItemID}
                    </span>
                    <span className='product-grid__title'>{Title}</span>
                </div>
                <div className='product-grid__label-wrapper'>
                    {IsSale === true && (
                        <span className='product__label product__label--red'>
                            On Sale
                        </span>
                    )}
                </div>
                <div className='product-grid__price-wrapper'>
                    <ProductGridPrice {...props} />
                </div>
            </a>
        </div>
    );
}

// default props
ProductSliderItem.defaultProps = {
    item: {},
};
// validate props
ProductSliderItem.propTypes = {
    item: PropTypes.object.isRequired,
};

export default ProductSliderItem;
